export const DICT = {
  fr: {
    dashboard: "Tableau de bord", search: "Recherche", identity: "Identité", image: "Image", air: "Aérien", cyber: "Cyber",
    ai: "Assistant IA", dossiers: "Dossiers & Rapports", admin: "Administration", sources: "Sources & coûts",
    geo: "Géospatial", graph: "Graphe", monitor: "Veille", planned: "Phase suivante",
    search_placeholder: "Email, pseudo, domaine, IP, téléphone, ICAO24, immatriculation, CVE, coordonnées…",
    run: "Lancer", logout: "Déconnexion", theme: "Thème", language: "Langue", detected: "Type détecté",
    login_title: "Accès sécurisé", login_sub: "Plateforme souveraine d'investigation numérique — sans abonnement.",
    email: "Adresse électronique", password: "Mot de passe", sign_in: "Se connecter",
    results: "Résultats", connectors: "Connecteurs", export: "Exporter", filters: "Filtres", reliability: "Fiabilité",
    no_results: "Aucun résultat", loading: "Chargement…", save: "Enregistrer", create: "Créer", cancel: "Annuler",
    group_intel: "Renseignement", group_analysis: "Analyse", group_gov: "Gouvernance",
  },
  en: {
    dashboard: "Dashboard", search: "Search", identity: "Identity", image: "Image", air: "Air", cyber: "Cyber",
    ai: "AI Assistant", dossiers: "Cases & Reports", admin: "Administration", sources: "Sources & costs",
    geo: "Geospatial", graph: "Graph", monitor: "Monitoring", planned: "Next phase",
    search_placeholder: "Email, username, domain, IP, phone, ICAO24, registration, CVE, coordinates…",
    run: "Run", logout: "Log out", theme: "Theme", language: "Language", detected: "Detected type",
    login_title: "Secure access", login_sub: "Sovereign digital investigation platform — no subscription.",
    email: "Email address", password: "Password", sign_in: "Sign in",
    results: "Results", connectors: "Connectors", export: "Export", filters: "Filters", reliability: "Reliability",
    no_results: "No results", loading: "Loading…", save: "Save", create: "Create", cancel: "Cancel",
    group_intel: "Intelligence", group_analysis: "Analysis", group_gov: "Governance",
  },
};

export const TYPE_LABELS = {
  email: "Adresse électronique", username: "Pseudonyme", domain: "Nom de domaine", url: "URL", ip: "Adresse IP",
  company: "Entreprise", technical_id: "Identifiant technique", phone: "Téléphone", fullname: "Nom et prénom",
  firstname: "Prénom", lastname: "Nom", aircraft_registration: "Immatriculation aéronef", callsign: "Indicatif d'appel",
  icao24: "Code ICAO24 / Mode-S", coordinates: "Coordonnées", cve: "Vulnérabilité CVE",
};

export const EPISTEMIC = {
  verified_fact: { fr: "FAIT VÉRIFIÉ", en: "VERIFIED FACT", cls: "bg-emerald-500/15 text-emerald-500 border-emerald-500/40" },
  source_reported: { fr: "SOURCE", en: "SOURCE-REPORTED", cls: "bg-blue-500/15 text-blue-400 border-blue-500/40" },
  probable_correlation: { fr: "CORRÉLATION", en: "CORRELATION", cls: "bg-amber-500/15 text-amber-500 border-amber-500/40" },
  hypothesis: { fr: "HYPOTHÈSE", en: "HYPOTHESIS", cls: "bg-purple-500/15 text-purple-400 border-purple-500/40" },
  unverified: { fr: "NON VÉRIFIÉ", en: "UNVERIFIED", cls: "bg-rose-500/15 text-rose-400 border-rose-500/40" },
};
